import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ isOpen, onClose }) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>¡Éxito!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p>El nuevo miembro ha sido creado exitosamente.</p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="success" onClick={onClose}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;
